import { useEffect, useState } from 'react';
import { ViewModeSwitch } from '@/components/ViewModeSwitch/ViewModeSwitch';
import { useNavbar } from '@/context/NavbarContext';
import appIcon from '@/assets/icons/app-icon.svg';
import arrowLeftIcon from '@/assets/icons/icon-arrow-left.svg';
import { useLocation } from 'react-router-dom';
import { ALL_ROUTES } from '@/Router';
import { LanguageSwitcher } from '../LanguageSwitcher/LanguageSwitcher';

const isDev = import.meta.env.DEV;

export function HeaderMobile() {
  const [isViewModeSwitchVisible, setIsViewModeSwitchVisible] = useState(false);
  const { showBackButton, onBackClick } = useNavbar();
  const location = useLocation();

  const isHome = location.pathname === ALL_ROUTES.basePath;

  const handleClickSwitchButton = () => {
    if (isDev) {
      setIsViewModeSwitchVisible(!isViewModeSwitchVisible);
    }
  };

  useEffect(() => {
    if (!isHome && isViewModeSwitchVisible) {
      setIsViewModeSwitchVisible(false);
    }
  }, [location, isHome, isViewModeSwitchVisible]);

  return (
    <header className={`p-app flex flex-col ${isHome ? 'bg-white' : ''}`}>
      {/* Top row: Back Button / Logo + Language flags */}
      <div className="flex items-center justify-between">
        {isHome ? (
          <>
            {/* Filologica logo — DEV: clickable button to toggle view mode; PROD: static, non-interactive */}
            {isDev ? (
              <button
                onClick={handleClickSwitchButton}
                className="logoButton flex items-center cursor-pointer transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-primary min-h-11 min-w-11"
                aria-label="Toggle view mode settings"
                type="button"
              >
                <img src={appIcon} alt="" aria-hidden="true" className="h-auto object-cover" />
              </button>
            ) : (
              <div className="logoButton flex items-center">
                <img src={appIcon} alt="Società Filologica Friulana" className="h-auto object-cover" />
              </div>
            )}

            <LanguageSwitcher />
          </>
        ) : (
          <>
            {showBackButton && (
              <button
                onClick={onBackClick}
                className="flex items-center justify-center h-10 w-10 bg-white rounded-full cursor-pointer transition-opacity hover:opacity-80 focus-visible:outline-2 focus-visible:outline-primary shadow-sm"
                aria-label="Go back to previous page"
                title="Back"
              >
                <img
                  src={arrowLeftIcon}
                  alt=""
                  className="w-5 h-5"
                  aria-hidden="true"
                />
              </button>
            )}
          </>
        )}
      </div>

      {/* View Mode Switch (hidden by default, shown on logo click) */}
      {
        isDev &&
        <div
          className={`transition-all duration-300 overflow-hidden ${
            isViewModeSwitchVisible
              ? 'opacity-100 max-h-20'
              : 'opacity-0 max-h-0 pointer-events-none'
          }`}
        >
          <ViewModeSwitch />
        </div>
      }
    </header>
  );
}
